import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros, all = false) {
  return httpAuth.get(`/admin/ecommerce_carrinho_fase?${serialize({ ...filtros, all })}`, {
    tela: 'ecommerce_carrinho_fase'
  })
}

export async function get (id) {
  return httpAuth.get(`/admin/ecommerce_carrinho_fase/${id}`, {
    tela: 'acesso_ecommerce_carrinho_fase'
  })
}

export async function edit (id, dados) {
  return httpAuth.put(`/admin/ecommerce_carrinho_fase/${id}`, dados)
}
